var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21,
    fill: "#FAFAFA",
    stroke: "#A5BFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9427 17.4572C13.7713 17.8857 13.6855 18.3143 13.6855 18.7429V29.2C13.6855 30.9143 15.057 32.2857 16.7713 32.2857H27.2284C28.9427 32.2857 30.3141 30.9143 30.3141 29.2V14.8C30.3141 13.0857 28.9427 11.7143 27.2284 11.7143H20.7141C20.2855 11.7143 19.857 11.8 19.4284 11.9714C19.0855 12.1429 18.8284 12.3143 18.5713 12.5714L14.6284 16.5143C14.3713 16.7714 14.1141 17.1143 13.9427 17.4572ZM20.8855 22.3429C21.1427 22.3429 21.4855 22.4286 21.7427 22.5143V17.3714C21.7427 17.0286 21.9141 16.6857 22.257 16.6C22.5998 16.4286 22.9427 16.5143 23.1998 16.7714L25.5141 19.0857C25.857 19.4286 25.857 19.9429 25.5141 20.2857C25.1713 20.6286 24.657 20.6286 24.3141 20.2857L23.457 19.4286V24.8286C23.457 26.2857 22.257 27.4 20.8855 27.4C19.4284 27.4 18.3141 26.2857 18.3141 24.8286C18.3141 23.4572 19.4284 22.3429 20.8855 22.3429Z",
    fill: "#FF8800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg5);
export default __webpack_public_path__ + "static/media/svg5.2a1b91766316781ecef6ce8fcab4691b.svg";
export { ForwardRef as ReactComponent };